import axiosInstance from "../api/api";

const ProjectService = {
    list: function () {
        return axiosInstance({
            url: "/api/project/",
            method: "GET",
        });
    },
    fetch: function (uniqueId) {
        return axiosInstance({
            url: `/api/project/${uniqueId}`,
            method: "GET",
        });
    },
    delete: function (uniqueId) {
        return axiosInstance({
            url: `/api/project/${uniqueId}`,
            method: "DELETE",
        });
    },
    create: function (formData) {
        return axiosInstance({
            url: `/api/project/`,
            method: "POST",
            data: formData,
        });
    },
    update: function (formData) {
        return axiosInstance({
            url: `/api/project/`,
            method: "PATCH",
            data: formData,
        });
    },
};
export default ProjectService;
